export const DEFAULT_CURRENCY = 'ETB';
export function formatMoneyMinor(minorAmount, currency = DEFAULT_CURRENCY) {
    const isNegative = minorAmount < 0;
    const absAmount = Math.abs(minorAmount);
    const major = Math.floor(absAmount / 100);
    const minor = absAmount % 100;
    const formatted = `${major}.${minor.toString().padStart(2, '0')}`;
    return `${isNegative ? '-' : ''}${formatted} ${currency}`;
}
export function parseMoneyToMinor(amountStr) {
    const clean = amountStr.trim().replace(/,/g, '');
    if (!/^-?\d+(\.\d{1,2})?$/.test(clean)) {
        throw new Error(`Invalid money string format: "${amountStr}"`);
    }
    const [majorPart, minorPart = ''] = clean.split('.');
    const isNegative = clean.startsWith('-');
    const major = Math.abs(parseInt(majorPart, 10));
    const minor = parseInt(minorPart.padEnd(2, '0').slice(0, 2), 10) || 0;
    const total = major * 100 + minor;
    return isNegative ? -total : total;
}
export function calculatePercentDiscount(subtotalMinor, percentValue) {
    if (percentValue < 0 || percentValue > 100) {
        throw new Error('Percent discount must be between 0 and 100');
    }
    // Integer arithmetic: round half up or floor
    return Math.round((subtotalMinor * percentValue) / 100);
}
//# sourceMappingURL=money.js.map